<template>
  <div>
  <v-app-bar
    :clipped-left="$vuetify.breakpoint.mdAndUp"
    :app="$vuetify.breakpoint.mdAndUp"
    :fixed="$vuetify.breakpoint.mdAndUp"
    flat
    :scroll-toolbar-off-screen="$vuetify.breakpoint.smAndDown"
    color="primary"
    :scroll-threshold="50"
    max-height="56"
    dark>
    <v-app-bar-nav-icon @click.stop="drawer = drawer!==true"
                        class="hidden-lg-and-up"></v-app-bar-nav-icon>
    <div class="d-flex align-center">
      <span class="mr-2">Запомни и поделись</span>
    </div>

    <v-spacer></v-spacer>

  </v-app-bar>
  <v-navigation-drawer
    v-model="drawer"
    clipped
    app
  >
    <categories-list />
  </v-navigation-drawer>

  <v-content>
    <slot />
  </v-content>
  </div>
</template>

<script>
import CategoriesList from '../CategoriesList.vue';

export default {
  name: 'MainLayout',
  components: {
    CategoriesList,
  },
  data: () => ({
    drawer: null,
  }),
};
</script>

<style scoped>

</style>
